$(function () {
  var messages = {};

  // await all translations to load before continuing
  $.when(
    Neos.translate(function (result, err) {
      messages.noticeUnrenderable = result;
    }, 'form.unrenderableNotice', 'Main', 'Obis.Form'),
    Neos.translate(function (result, err) {
      messages.errorPrefix = result;
    }, 'form.errorPrefix', 'Main', 'Obis.Form'),
    Neos.translate(function (result, err) {
      messages.errorSuffix = result;
    }, 'form.errorSuffix', 'Main', 'Obis.Form'),
    Neos.translate(function (result, err) {
      messages.errorTimeout = result;
    }, 'form.ajax.status.timeout', 'Main', 'Obis.Form'),
    Neos.translate(function (result, err) {
      messages.errorUnknown = result;
    }, 'form.ajax.status.error', 'Main', 'Obis.Form'),
    Neos.translate(function (result, err) {
      messages.errorAbort = result;
    }, 'form.ajax.status.abort', 'Main', 'Obis.Form'),
    Neos.translate(function (result, err) {
      messages.errorParser = result;
    }, 'form.ajax.status.parsererror', 'Main', 'Obis.Form'),
    Neos.translate(function (result, err) {
      messages.errorMissingId = result;
    }, 'content.noValidFormIdentifier', 'NodeTypes/Form', 'Neos.NodeTypes.Form'),
  ).then(function () {
    // all requests have finished, now continue loading

    // initialize each form that has ajax enabled
    $('.obis-form-form.ajax-form').each(function (i, e) {
      var element = $(this);

      // display an error message in the form
      function setErrorStatus(status) {
        $(element).html('<p class="error">' + status + '</p>');
      }
      
      // display a notice in the form
      function setNotice(notice) {
        $(element).html('<p class="notice">' + notice + '</p>');
      }

      // display the configured loading spinner in the form
      function setLoading() {
        // Inject loading icon as content
        $(element).html('<div class="loading"><i class="' + element.data('loading').replace('_', ' ') + ' fa-spin"></i></div>');
      }

      // handle possible ajax error cases and display a proper message for these 
      function handleError(jqXHR, textStatus, errorThrown) {
        if (textStatus === "timeout") {
          setErrorStatus(messages.errorTimeout);
        } else if (textStatus === "error") {
          if (isset(errorThrown, "string")) {
            setErrorStatus(messages.errorPrefix + ':<br>' + errorThrown + '<br>' + messages.errorSuffix);
          } else {
            setErrorStatus(messages.errorPrefix + ':<br>' + messages.errorUnknown + '<br>' + messages.errorSuffix);
          }
        } else if (textStatus === "abort") {
          setErrorStatus(messages.errorAbort + '<br>' + messages.errorSuffix);
        } else if (textStatus === "parsererror") {
          setErrorStatus(messages.errorPrefix + ':<br>' + messages.errorParser + '<br>' + messages.errorSuffix);
        } else if (isset(errorThrown, "string")) {
          setErrorStatus(messages.errorPrefix + ':<br>' + errorThrown + '<br>' + messages.errorSuffix);
        } else {
          setErrorStatus(messages.errorPrefix + ':<br>' + messages.errorUnknown);
        }
      }

      // handle a successful ajax response by inserting and optionally reinitializing the returned contents
      function handleResponse(data, textStatus, jqXHR) {
        $(element).children('.loading').replaceWith(data);

        if ($(element).has('.g-recaptcha').length > 0) {
          if (window.Cookies) {
            if (!Cookies.allowed('essential')) {
              setNotice(messages.noticeUnrenderable);
            }

            Cookies.on('accept_all', ((event) => initAjaxFormOnElement(this)).bind(element), {once: true});
            Cookies.on('save_and_close', ((event) => {
              if (Cookies.allowed('essential')) {
                initAjaxFormOnElement(this);
              }
            }).bind(element));
          } else if (window.CookieConsentAPI && !CookieConsentAPI.hasConsented()) {
            setNotice(messages.noticeUnrenderable);

            window.addEventListener('cc_user_consented', (((event) => {
              initAjaxFormOnElement(this);
            }).bind(element)), {once: true});
          } else {
            $(element).find('.g-recaptcha').each(function (i, e) {
              initReCaptchaOnElement(e);
            });
          }
        }

        if ($(element).has('form').length > 0) {
          $(element).children('form').one('submit', handleSubmit);
        }

        window.dispatchEvent(new Event('ajax_form_load_success'));
      }

      // handle one concurrent form submission
      function handleSubmit(event) {
        event.preventDefault();
        event = event.originalEvent;

        var element = event.target;
        var method = element.getAttribute('method');
        var action = element.getAttribute('action');
        var data = new FormData(element);

        // add the "currentPage" value to the form data, which depends on the clicked submit button
        if (event.submitter) {
          var name = $(event.submitter).attr('name');
          var value = $(event.submitter).attr('value');

          if (isset(name, 'string') && isset(value)) {
            //? maybe check for existence inside formdata beforehand?
            data.set(name, value);
          }
        }

        setLoading();
        $.ajax({
          dataType: "html",
          method: method.toUpperCase(),
          url: action,
          data: data,
          timeout: 60000,
          processData: false,
          contentType: false,
          error: handleError,
          success: handleResponse,
        });
      }

      // initialize an ajax form element
      function initAjaxFormOnElement(node) {
        node = $(node);
        var ajaxTarget = node.data('ajax');

        if (isset(ajaxTarget, 'string')) {
          $.ajax({
            dataType: "html",
            method: "GET",
            url: ajaxTarget,
            timeout: 60000,

            error: handleError,
            success: handleResponse,
          });
        } else if (Neos.inBackend()) {
          if (!isset(node.data('id'), 'string')) {
            setErrorStatus(messages.errorMissingId);
          } else {
            setErrorStatus(messages.errorUnknown);
          }
        }
      }

      initAjaxFormOnElement(element);
    });

    function addUnrenderableNotice() {
      // go through all non-ajax forms too, to inject the "unrenderable" notice if consent is missing
      $('.obis-form-form').not('.ajax-form').each(function (i, e) {
        if ($(this).has('.g-recaptcha').length > 0) {
          this._previousHtmlContent = $(this).html();
          $(this).html('<p class="notice">' + messages.noticeUnrenderable + '</p>');
        }
      });
    }

    function revertUnrenderableNotice() {
      $('.obis-form-form').not('.ajax-form').each(function (i, e) {
        if ($(this).has('.g-recaptcha').length > 0) {
          $(this).html(this._previousHtmlContent);
        }
      });
    }

    if (window.Cookies) {
      if (!Cookies.allowed('essential')) {
        addUnrenderableNotice();
      }

      Cookies.on('accept_all', ((event) => revertUnrenderableNotice).bind(element), {once: true});
      Cookies.on('save_and_close', ((event) => {
        if (Cookies.allowed('essential')) {
          revertUnrenderableNotice();
        }
      }).bind(element));
    } else if (window.CookieConsentAPI) {
      if (!CookieConsentAPI.hasConsented('functional')) {
        addUnrenderableNotice();

        // reset all non-ajax forms to their previous contents on consent
        window.addEventListener('cc_user_consented', (event) => revertUnrenderableNotice, false);
      }
    }
  });
});